"use client"

import { t } from "@/languages/i18n"
import { Card, Col, Form, Input, Radio, Row, Space } from "antd"
import { FormInstance } from "antd/lib"
import React from "react"
import CKEditorWrapper from "../../../../lib/config/lib/CkeditorWrapper"

interface SupplierFormFieldsProps {
    form: FormInstance
    isReady: boolean
    onValuesChange?: () => void
}

const SupplierFormFields: React.FC<SupplierFormFieldsProps> = ({
    form,
    isReady,
    onValuesChange
}) => {

    return (
        <Space direction="vertical" size="large" className="w-full">
            <Card title={t("Basic Information")} size="small">

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="fullname"
                            label={<span className="font-medium">{t("Họ và tên")}</span>}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="position"
                            label={<span className="font-medium">{t("Vị trí")}</span>}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="companyName"
                            label={<span className="font-medium">{t("Tên công ty")}</span>}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="ico"
                            label={<span className="font-medium">{"ico"}</span>}
                            rules={[{ required: true, message: t("Vui lòng nhập ico!") },
                            {
                                pattern: /^[0-9]+$/,
                                message: t("ico chỉ được bao gồm các chữ số!")
                            }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="dic"
                            label={<span className="font-medium">{"dic"}</span>}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="phoneNumber"
                            label={<span className="font-medium">{t("Số điện thoại")}</span>}
                            rules={[{ required: true, message: t("Vui lòng nhập Số điện thoại!") },
                            {
                                pattern: /^[0-9]+$/,
                                message: t("Số điện thoại chỉ được bao gồm các chữ số!")
                            },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="email"
                            label={<span className="font-medium">{"Email"}</span>}
                            validateTrigger="onBlur"
                            rules={[{ required: true, message: t("Vui lòng nhập Email!") },
                            {
                                type: "email",
                                message: t("Email không đúng định dạng!")
                            }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="companyAddress"
                            label={<span className="font-medium">{t("Địa chỉ công ty")}</span>}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>



                {isReady && (<Form.Item name="note" label={<span className="font-medium">{t("Ghi chú")}</span>}>
                    <div
                        style={{
                            height: "auto",
                            overflowY: "auto",
                            position: "relative",
                        }}
                    >
                        <CKEditorWrapper
                            value={form.getFieldValue("note")}
                            onChange={(data: string) => {
                                form.setFieldsValue({ note: data })
                                if (onValuesChange) onValuesChange()
                            }}
                        />
                    </div>
                </Form.Item>)}

                <Form.Item name="resolved" label={<span className="text-base font-medium">{t("Đã giải quyết")}</span>}>
                    <Radio.Group buttonStyle="solid">
                        <Radio.Button value={false}>{t("Chưa")}</Radio.Button>
                        <Radio.Button value={true}>{t("Rồi")}</Radio.Button>
                    </Radio.Group>
                </Form.Item>
            </Card>
        </Space>

    )
}

export default SupplierFormFields